import {
    isValueExist,
    innerHtmlJSX,
    srcset2X,
    showAuthLink,
    guaranteeArray,
    filterDeprecated,
} from '@util';

import styled, { css } from 'vue-styled-components';

import {
    BLUE,
    GRAY_COLOR,
    FONT_SIZE,
    FONT_WEIGHT,
    BLUE_COLOR,
    FLEX_SHRINK_0,
    WIDTH_100_PERCENT,
    CURSOR_POINTER,
    PADDING,
    square,
    ABSOLUTE_BOTH_CENTER,
    ABSOLUTE_FULL_AREA,
    GRAY,
    applyHoverAndPress,
} from '@styles/common.styled';

import {
    FLEX_CENTER_DIV,
    FLEX_COLUMN_DIV,
    GRAY_100_DIV,
    make,
    FLEX_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@styles/common.styled.component';
import GoogleAuthButton from '@/components/Common/GoogleAuthButton';

import StatusInput from '@components/Common/StatusInput';

import debounce from 'lodash/debounce';
import { lighten } from 'polished';
import NextIcon from '@svgIcons/next.svg';
import { CONNECTION_TYPES } from '@consts';
import { AssetService } from '@/services';
import { NOTI_TYPES } from '@/store/dashboardEdit';

import FbPageShareModal from '@/components/Common/FbPageShareModal';
import PixelShareModal from '@/components/Common/PixelShareModal.js';
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';

import { gtm } from '@/utils/tracker/googleTagManager';

const AdverityModal = () =>
    import('@/components/Dashboard/DashboardConnection');

const FbAppShareModal = () => import('@/components/Common/FbAppShareModal.vue');
const YouTubeShareModal = () =>
    import('@/components/Common/YouTubeShareModal.js');
const YelpShareModal = () => import('@/components/Common/YelpShareModal');
const ShareWithInputModal = () =>
    import('@/components/connection/ShareWithInputModal');

import FacebookLogo from '@svgIcons/facebook_round_color.svg';
import KakaoLogo from '@svgIcons/channel_kakao.svg';
import YoutubeIcon from '@svgIcons//channel_youtube.svg';

// import AppStoreConnectIcon from '@svgIcons/apple_color.svg';
// import PlayStoreIcon from '@svgIcons/channel_google_play_color.svg';

// PLACEHOLDER for channel icon

const {
    PIXEL,
    GA,
    FB_PAGE,
    FB_APP,
    YELP_ACCOUNT,
    YOUTUBE_CHANNEL,
    GOOGLE_AD_ACCOUNT,
    GOOGLE_SHEETS,
    APPSTORECONNECT_ACCOUNT,
    PLAYSTORE_ACCOUNT,
    ADVERITY,
    GA4,
    AIRBYTE,
    INTERNAL,
    // PLACEHOLDER for CONNECTION_TYPES
} = CONNECTION_TYPES;

const FROM_KEYS = R.compose(
    R.fromPairs,
    R.xprod(Object.values(CONNECTION_TYPES)),
    R.of,
    R.clone
);

const JOINER = R.compose(R.join(' | '), R.filter(R.identity), R.uniq);

export const FB_PAGE_OPTION = {
    text: 'facebook_page',
    logo: FacebookLogo,
    type: FB_PAGE,
    textGenerator: R.compose(
        JOINER,
        R.props(['name', 'facebookPageId', 'websiteUrl', 'id']),
        R.prop('data')
    ),
};

const NEW_CONNECTORS_MODAL_META = 'NEW_CONNECTORS_MODAL_META';

export const NEW_CONNECTORS = new Set([AIRBYTE, INTERNAL, ADVERITY]);

export const OPTIONS = [
    {
        text: 'facebook_pixel',
        logo: FacebookLogo,
        type: PIXEL,
        textGenerator: R.compose(
            JOINER,
            R.props(['name', 'id']),
            R.prop('data')
        ),
    },
    FB_PAGE_OPTION,
    {
        text: 'facebook_sdk',
        logo: FacebookLogo,
        forMobile: true,
        type: FB_APP,
        textGenerator: R.compose(
            JOINER,
            R.props(['name', 'facebookPageId', 'websiteUrl', 'id']),
            R.prop('data')
        ),
    },
    {
        text: 'youtube_channel',
        logo: YoutubeIcon,
        type: YOUTUBE_CHANNEL,
        textGenerator: R.compose(JOINER, R.props(['title']), R.prop('data')),
    },
    // PLACEHOLDER for OPTIONS
];

const LOADING_META = 'loadingMeta';
const MODAL_META = 'modalMeta';

const GOOGLE_ADS = 'internal_google';
const GOOGLE_ANALYTICS = 'internal_googleAnalytics';
const GOOGLE_ANALYTIVS4 = 'internal_googleAnalytics4';
const GOOGLE_SPREADSHEET = 'internal_googleSpreadSheet';
const GOOGLE_DV360 = 'internal_dv360';
const YOUTUBE_PUBLIC = 'internal_youtubePublic';

const GOOGLES_CONNECTORS = new Set([
    GOOGLE_ADS,
    GOOGLE_ANALYTICS,
    GOOGLE_ANALYTIVS4,
    GOOGLE_SPREADSHEET,
    GOOGLE_DV360,
    YOUTUBE_PUBLIC,
]);

export const Wrapper = make({
    base: FLEX_COLUMN_DIV,
    styles: [
        PADDING[24],
        css`
            width: 528px;
        `,
    ],
});

export const WrapperBig = make({
    base: Wrapper,
    styles: [
        PADDING[24],
        css`
            width: 848px;
        `,
    ],
});

const TitleArea = make({
    base: GRAY_100_DIV,
    styles: [
        FONT_WEIGHT[500],
        FONT_SIZE[16],
        css`
            display: flex;
            align-items: center;
            .info-tooltip {
                margin-left: 8px;
                svg {
                    width: 16px;
                    height: 16px;
                }
            }
        `,
    ],
});

export const BodyArea = make({
    base: FLEX_COLUMN_DIV,
    styles: [
        css`
            margin-top: 24px;
        `,
    ],
});
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        token: {
            type: String | Number,
            required: true,
        },
    },
    components: {
        Wrapper,
        BodyArea,
        WrapperBig,
    },
    computed: {
        ...mapState('user', ['adAccountData']),
        ...mapGetters('user', ['accountToken', 'pricePlanSettings']),
        ...mapGetters('permission', ['connectionCredentialsManageable']),
        ...mapState('newDashboard', ['tableAdAccounts']),
        ...mapState('asset', { mixinAssets: 'connections' }),
        _active: {
            get: R.prop('active'),
            set(value) {
                this.$emit('update:active', value);
            },
        },
        allFilled: R.compose(R.all(isValueExist), R.values, R.prop('value')),
        isDashboard: R.propEq('mixinFlag', 'dashboard'),
        queryToken: R.pathOr('', ['$route', 'query', 'token']),
    },
    data() {
        let defaultValues = FROM_KEYS(false);

        return {
            loadingProgress: false,
            dirty: false,
            failed: false,
            [MODAL_META]: defaultValues,
            [LOADING_META]: defaultValues,
            removeEventFn: R.identity,
            assetService: AssetService,
        };
    },
    methods: {
        ...mapActions('user', ['fetchAssetThroughLink']),
        ...mapMutations('user', ['setAdAccountData']),
        ...mapMutations('view', ['addNotiMsg']),
        updateValue: R.curry(function (key, value) {
            this.value = R.assoc(key, value, this.value);
        }),
        getErrorText(key) {
            return this.dirty && !this.value[key]
                ? this.$t('COMMON.required')
                : '';
        },
        handleCancel() {
            this._active = false;
        },
        renderTitle(t) {
            return <TitleArea>{t}</TitleArea>;
        },
        renderTitleWithTooltip(t, tooltipText) {
            return (
                <TitleArea>
                    {t}
                    <info-tooltip label={tooltipText} />
                </TitleArea>
            );
        },
        renderStepRow({
            number,
            text,
            key,
            troubleUrl,
            children,
            inputType = 'input',
        }) {
            return (
                <ElemRow>
                    <ElemColumn>
                        <ElemRowTextArea>
                            {this.renderBadge(number)}
                            <EachText {...innerHtmlJSX(text)} />
                            {troubleUrl && this.renderTrouble(troubleUrl)}
                        </ElemRowTextArea>
                        {key && (
                            <ElemRowInputArea>
                                {this.renderInput(key, inputType)}
                            </ElemRowInputArea>
                        )}
                        {children}
                    </ElemColumn>
                </ElemRow>
            );
        },
        renderBadge(num) {
            return <Badge>Step {num}</Badge>;
        },
        renderInput(key, inputType) {
            const { value, updateValue, getErrorText } = this;

            return (
                <StatusInput
                    counterVisible={false}
                    value={value[key]}
                    onInput={updateValue(key).bind(this)}
                    errorText={getErrorText(key)}
                    inputType={inputType}
                />
            );
        },
        renderTrouble(url) {
            return (
                <TroubleText href={url} target="_blank">
                    {this.$t('CONNECTION.criteo_trouble_finding')}
                </TroubleText>
            );
        },
        renderCarousel({ imgSrc, lastIndex } = {}) {
            const { index } = this;
            const isLast = lastIndex === index;

            const step = R.inc(index);
            const lastStep = R.inc(lastIndex);
            const stepText = `${step} /${lastStep}`;

            return (
                <CarouselArea class="carousel-area">
                    <SlideWrapper>
                        {this.index !== 0 && (
                            <SlideButton
                                class="left"
                                onClick={() => this.index--}
                            >
                                <SlideButtonBg />
                                <NextIcon v-view-box />
                            </SlideButton>
                        )}
                        {!isLast && (
                            <SlideButton
                                class="right"
                                onClick={() => this.index++}
                            >
                                <SlideButtonBg />
                                <NextIcon v-view-box />
                            </SlideButton>
                        )}
                        <img src={imgSrc} srcset={srcset2X(imgSrc)} />
                    </SlideWrapper>
                    <SlideIndexButton>{stepText}</SlideIndexButton>
                </CarouselArea>
            );
        },
        renderBanner(t) {
            return <BannerWrapper>{t}</BannerWrapper>;
        },
        renderImg(imgSrc) {
            return (
                <ImgWrapper>
                    <img src={imgSrc} srcset={srcset2X(imgSrc)} />
                </ImgWrapper>
            );
        },
        renderNewConnectorDrawer() {
            if (!R.path([MODAL_META, NEW_CONNECTORS_MODAL_META], this)) {
                return;
            }
            const _updateModal = this.updateModalMeta(
                NEW_CONNECTORS_MODAL_META
            ).bind(this);

            const modalProps = {
                attrs: {
                    token: this.token,
                    active: true,
                    isConnectionPage: true,
                    streamItem: this.streamItem,
                },
                on: {
                    'update:active': _updateModal,
                    close: () => _updateModal(false),
                    refresh: (data = []) => {
                        console.log('refresh', data);
                        const type = R.pathOr('', [0, 'type'], data);

                        this.isDashboard
                            ? this.refreshAdAccounts()
                            : this.updateAddedMultiple(type, data);
                    },
                },
            };

            return <AdverityModal {...modalProps} />;
        },
        renderGoogleInfoModal({ type, cb = R.identity, cancelCb }) {
            const instance = this.dialog({
                text: this.$t(
                    'CONNECTION.google_spreadsheet_oauth_desctiption'
                ),
                slots: {
                    confirmButton: (
                        <div
                            onClick={() => {
                                cb(type);

                                instance.destroy();
                            }}
                        >
                            <GoogleAuthButton />
                        </div>
                    ),
                },
                ...(cancelCb && { cancelCb }),
            });

            return instance;
        },
        renderShareWithInputModal() {
            const TYPE = R.compose(
                R.head,
                R.keys,
                R.filter((account) => account),
                R.pick([
                    // LIST all channel types with input (ex. criteo)
                    APPSTORECONNECT_ACCOUNT,
                    PLAYSTORE_ACCOUNT,
                    // PLACEHOLDER_INPUT_MODAL
                ]),
                R.prop(MODAL_META)
            )(this);

            if (!TYPE) {
                return;
            }

            const _updateModal = this.updateModalMeta(TYPE).bind(this);

            const modalProps = {
                attrs: {
                    token: this.token,
                    active: true,
                    channel: TYPE,
                },
                on: {
                    'update:active': _updateModal,
                    input: ([data] = []) => {
                        if (this.isDashboard) {
                            this.refreshAdAccounts();
                        } else {
                            this.updateAdded(TYPE, data);
                            _updateModal(false);
                        }
                    },
                },
            };

            return <ShareWithInputModal {...modalProps} />;
        },
        handleActionBtnClick(type) {
            // 권한(credential 생성 불가) 가드는 분기별로 적용한다.
            // - 순수 생성 분기(OAuth 팝업 showAuthLink 그룹, Yelp share 모달)는
            //   여기서 막는다 — 기존 credential 패널이 없어서 항상 생성으로 이어진다.
            // - 구글 분기와 default(NEW_CONNECTORS)는 DashboardConnection 패널로
            //   흘려보낸다. 그쪽 onClickDatastreamType이 credential 존재 시 패널을
            //   열고(삭제 가능), 없을 때만 권한 보고 실패 noti를 띄운다.
            //   (메서드 전체를 막으면 credential이 있어도 항상 실패 noti — 버그)
            const blockedByPermission = () => {
                if (this.connectionCredentialsManageable) {
                    return false;
                }

                this.addNotiMsg({
                    type: NOTI_TYPES.FAIL,
                    title: this.$t('COMMON.permission_denied_tooltip'),
                });
                return true;
            };

            if (isValueExist(this.pricePlanSettings)) {
                const { nbOfConnections = Number.MAX_SAFE_INTEGER } =
                    this.pricePlanSettings;

                const list =
                    this.mixinFlag === 'connection' ? this.added : this.assets;

                const assetLength = R.compose(R.length, filterDeprecated)(list);

                if (nbOfConnections && nbOfConnections <= assetLength) {
                    this.renderWarningToLimiedUser();
                    return;
                }
            }

            switch (type) {
                case FB_PAGE:
                case PIXEL:
                case FB_APP:
                case YOUTUBE_CHANNEL:
                case APPSTORECONNECT_ACCOUNT:
                case PLAYSTORE_ACCOUNT:
                    if (blockedByPermission()) {
                        return;
                    }

                    // PLACEHOLDER for action btn
                    this.removeEventFn = showAuthLink({
                        type,
                        cb: this.fetchAssetThroughLinkWithLoader,
                    });
                    break;
                case YELP_ACCOUNT:
                    if (blockedByPermission()) {
                        return;
                    }

                    this.renderCheckUsForYelp();
                    break;
                case GOOGLE_AD_ACCOUNT:
                case GA:
                case GOOGLE_SHEETS:
                case GA4:
                    this.renderGoogleInfoModal({
                        type,
                        cb: () => {
                            const refinedType = `internal_${type}`;

                            this.streamItem = {
                                id: refinedType,
                                connectionTypesIds: [refinedType],
                                haveAccess: true,
                            };

                            this.updateModalMeta(
                                NEW_CONNECTORS_MODAL_META,
                                true
                            );
                        },
                    });
                    break;
                default:
                    this.updateModalMeta(type, true);
                    // for detecting nothing happen
                    return type;
            }
        },
        renderPixelModal() {
            if (!R.path([MODAL_META, PIXEL], this)) {
                return;
            }
            const _updateModal = this.updateModalMeta(PIXEL).bind(this);

            const modalProps = {
                attrs: {
                    token: this.token,
                    active: true,
                },
                on: {
                    'update:active': _updateModal,
                    input: (results = []) => {
                        this.requestGtmEvent({
                            newAssets: results,
                            curAssets: this.mixinAssets,
                        });

                        if (this.isDashboard) {
                            this.refreshAdAccounts();
                        } else {
                            this.updateAddedMultiple(PIXEL, results);
                        }

                        _updateModal(false);
                    },
                },
            };

            return <PixelShareModal {...modalProps} />;
        },
        renderFbAppModal() {
            if (!R.path([MODAL_META, FB_APP], this)) {
                return;
            }
            const _updateModal = this.updateModalMeta(FB_APP).bind(this);

            const modalProps = {
                attrs: {
                    active: true,
                    token: this.token,
                },
                on: {
                    'update:active': _updateModal,
                    input: (results = []) => {
                        this.requestGtmEvent({
                            newAssets: results,
                            curAssets: this.mixinAssets,
                        });

                        if (this.isDashboard) {
                            this.refreshAdAccounts();
                        } else {
                            this.updateAddedMultiple(FB_APP, results);
                        }

                        _updateModal(false);
                    },
                },
            };

            return <FbAppShareModal {...modalProps} />;
        },
        renderYelpModal() {
            if (!R.path([MODAL_META, YELP_ACCOUNT], this)) {
                return;
            }
            const _updateModal = this.updateModalMeta(YELP_ACCOUNT).bind(this);

            const modalProps = {
                attrs: {
                    active: true,
                    token: this.token,
                },
                on: {
                    'update:active': _updateModal,
                    input: (results = []) => {
                        if (this.isDashboard) {
                            this.refreshAdAccounts();
                        } else {
                            this.updateAddedMultiple(YELP_ACCOUNT, results);
                        }

                        _updateModal(false);
                    },
                },
            };

            return <YelpShareModal {...modalProps} />;
        },
        renderFbPagesModal() {
            if (!R.path([MODAL_META, FB_PAGE], this)) {
                return;
            }

            const _updateModal = this.updateModalMeta(FB_PAGE).bind(this);

            const modalProps = {
                attrs: {
                    token: this.token,
                },
                on: {
                    'update:active': _updateModal,
                    input: (results = []) => {
                        this.requestGtmEvent({
                            newAssets: results,
                            curAssets: this.mixinAssets,
                        });

                        if (this.isDashboard) {
                            this.refreshAdAccounts();
                        } else {
                            this.updateAddedMultiple(FB_PAGE, results);
                        }

                        _updateModal(false);
                    },
                },
            };

            return <FbPageShareModal {...modalProps} />;
        },
        renderYoutubeChannelModal() {
            if (!R.path([MODAL_META, YOUTUBE_CHANNEL], this)) {
                return;
            }
            const _updateModal =
                this.updateModalMeta(YOUTUBE_CHANNEL).bind(this);

            const modalProps = {
                attrs: {
                    token: this.token,
                },
                on: {
                    'update:active': _updateModal,
                    input: (results = []) => {
                        this.requestGtmEvent({
                            newAssets: results,
                            curAssets: this.mixinAssets,
                        });

                        if (this.isDashboard) {
                            this.refreshAdAccounts();
                        } else {
                            this.updateAddedMultiple(YOUTUBE_CHANNEL, results);
                        }

                        _updateModal(false);
                    },
                },
            };

            return <YouTubeShareModal {...modalProps} />;
        },
        renderModals() {
            const {
                renderFbPagesModal,
                renderPixelModal,
                renderFbAppModal,
                renderYoutubeChannelModal,
                renderYelpModal,
                renderShareWithInputModal,
                renderNewConnectorDrawer,
            } = this;
            const modals = [
                renderFbPagesModal,
                renderPixelModal,
                renderFbAppModal,
                renderYoutubeChannelModal,
                renderYelpModal,
                renderShareWithInputModal,
                renderNewConnectorDrawer,
            ]
                .map(R.call)
                .filter(R.identity);

            return modals;
        },
        fetchAssetThroughLinkWithLoader(event) {
            const assetType = event.data.type;
            if (assetType) {
                this.updateLoadingMeta(assetType, true);
                this.fetchAssetThroughLink(event)
                    .catch(console.error)
                    .finally(() => {
                        this.removeEventFn();
                        this.updateLoadingMeta(assetType, false);
                        this.updateModalMeta(assetType, true);
                    });
            }
        },
        updateModalMeta: R.curry(function (key, value) {
            // reset dropdopwnMeta when any popup is visible
            if (value) {
                this.mixinFlag === 'connection' && this.resetDropdownMeta();
            }

            if (NEW_CONNECTORS.has(key)) {
                key = NEW_CONNECTORS_MODAL_META;
            }

            this[MODAL_META] = R.assoc(key, value, this[MODAL_META]);
        }),
        initAdAccountData() {
            this.setAdAccountData({ accounts: [], code: '' });
        },
        updateLoadingMeta: R.curry(function (key, value) {
            this[LOADING_META] = R.assoc(key, value, this[LOADING_META]);
        }),
        showAddedToast: debounce(function (customMessage) {
            return this.addNotiMsg({
                type: NOTI_TYPES.SUCCESS,
                title:
                    customMessage || this.$t('CONNECTION.added_successfully'),
            });
        }, 100),
        requestGtmEvent({ newAssets, curAssets }) {
            return guaranteeArray(newAssets).forEach((asset, index) =>
                gtm.logEvent('connect_complete', {
                    connect_media: asset.type || '',
                    connect_total: R.any(R.propEq('id', asset.id), curAssets)
                        ? curAssets.length
                        : curAssets.length + (index + 1),
                    connect_plan: this.planType,
                })
            );
        },
    },
};


const ElemRow = make({
    base: FLEX_DIV,
    styles: [
        css`
            flex: 1;
            &:not(:first-child) {
                margin-top: 24px;
            }
        `,
    ],
});

const ElemColumn = make({
    base: FLEX_COLUMN_DIV,
    styles: [WIDTH_100_PERCENT],
});

const ElemRowTextArea = make({
    base: FLEX_VERTICAL_CENTER_DIV,
});

const ElemRowInputArea = make({
    base: FLEX_DIV,
    styles: [
        css`
            margin-top: 16px;

            & > div {
                width: 100%;
            }

            input {
                height: 44px;
            }
        `,
    ],
});

const Badge = make({
    base: FLEX_CENTER_DIV,
    styles: [
        FONT_WEIGHT[500],
        FONT_SIZE[13],
        FLEX_SHRINK_0,
        css`
            min-width: 60px;
            height: 24px;
            border-radius: 12px;
            background-color: ${BLUE(60)};
            color: white;
            padding: 0 11px;
        `,
    ],
});

const EachText = make({
    base: styled.div``,
    styles: [
        FONT_SIZE[14],
        GRAY_COLOR[100],
        css`
            margin-left: 16px;
            a {
                ${BLUE_COLOR[60]}
            }
        `,
    ],
});

const TroubleText = make({
    base: styled.a``,
    styles: [
        CURSOR_POINTER,
        FONT_SIZE[13],
        applyHoverAndPress(GRAY(50), 'color'),
        css`
            display: flex;
            margin-left: 12px;
        `,
    ],
});

const CarouselArea = styled(FLEX_COLUMN_DIV)`
    position: relative;
`;

const SlideWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    position: relative;
    @media screen and (max-width: 767px) {
        width: 100%;
        height: auto;
    }
`;

const SlideButton = styled(FLEX_CENTER_DIV)`
    position: absolute;
    ${square(48)};
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;

    @media screen and (max-width: 767px) {
        ${square(32)};
    }

    &.left {
        left: 32px;
        svg {
            transform: rotate(180deg);
            transform-origin: 25% 25%;
        }
        @media screen and (max-width: 767px) {
            left: 20px;
        }
    }

    &.right {
        right: 32px;
        @media screen and (max-width: 767px) {
            right: 20px;
        }
    }

    svg {
        fill: white;
        ${ABSOLUTE_BOTH_CENTER}
        @media screen and (max-width: 767px) {
            ${square(16)};
        }
    }
`;

const SlideButtonBg = styled.div`
    background-color: rgba(0, 0, 0, 0.3);
    &:hover {
        background-color: ${lighten(0.1, 'rgba(0, 0, 0, 0.3)')};
    }
    &:active {
        background-color: ${lighten(0.2, 'rgba(0, 0, 0, 0.3)')};
    }
    ${ABSOLUTE_FULL_AREA};
`;

const SlideIndexButton = styled(FLEX_CENTER_DIV)`
    position: absolute;
    right: 24px;
    bottom: 12px;
    border-radius: 12px;
    background-color: rgba(0, 84, 198, 0.5);
    padding: 2px 12px;

    font-size: 13px;
    font-weight: 500;
    color: white;
`;

const BannerWrapper = make({
    base: FLEX_CENTER_DIV,
    styles: [
        FONT_SIZE[14],
        FONT_WEIGHT[500],
        css`
            min-height: 36px;
            background-color: ${BLUE(10)};
            width: calc(100% + 48px);
            transform: translateX(-24px);
            padding: 8px 24px;
            color: ${BLUE(80)};
        `,
    ],
});

const ImgWrapper = make({
    base: FLEX_CENTER_DIV,
    styles: [
        css`
            background-color: ${GRAY(10)};
            width: calc(100% + 48px);
            transform: translateX(-24px);
        `,
    ],
});
